<template>
    <div class="ui-empty">
        <v-icon large>{{ icon }}</v-icon>
        <div><slot>{{ text }}</slot></div>
    </div>
</template>

<script>
export default {
    name: "UiEmpty",
    props: {
        icon: { type: String, default: "mdi-inbox-outline" },
        text: { type: String, default: "Nenhum registro" },
    },
};
</script>
